export default __webpack_public_path__ + "static/media/jnh7.4bda5fc8.jpg";